import { reactive } from 'vue'  
export const globalState = reactive({  
  isVoiceActive: false,  
  isVoiceListening: false,  
  isVoiceSpeaking: false,  
  voiceStatus: 'Ready',  
  voiceTranscript: '',  
  shouldStopListening: false,   // <-- Add this line!  
  userID: "",
})  